/**
 * Utilidades para generación de datos de usuario
 */

/**
 * Genera un nombre a partir de un email
 * Ejemplo: "juan.perez@email.com" -> "Juan Perez"
 */
export function generateNameFromEmail(email: string): string {
  if (!email || typeof email !== 'string') {
    return 'Usuario';
  }
  
  const namePart = email.split('@')[0];
  if (!namePart) {
    return 'Usuario';
  }
  
  return namePart
    .split(/[._-]/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

/**
 * Genera un avatar aleatorio basado en el email
 * Usa pravatar.cc con un índice basado en el hash del email
 */
export function generateAvatar(email: string): string {
  if (!email || typeof email !== 'string') {
    return '';
  }
  
  const hash = email.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const imgIndex = (hash % 70) + 1; // 1-70 imágenes disponibles en pravatar
  return `https://i.pravatar.cc/150?img=${imgIndex}`;
}

/**
 * Extrae el nombre de usuario de un email
 */
export function extractUsernameFromEmail(email: string): string {
  if (!email || typeof email !== 'string') {
    return 'Usuario';
  }
  
  const namePart = email.split('@')[0];
  return namePart || 'Usuario';
}
